import { Member } from './Member';
import { Task } from './Task';

export enum TaskAssigneePermissionType {
    VIEW = 'View', // Read
    COMMENT = 'Comment', // "Update"
    EDIT = 'Edit', // Create, Delete
    OWNER = 'Owner', // Full-access (whoever created the investment)
}

export enum TaskAssigneeStatusType {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    DEACTIVATED = 'Deactivated',
    BLOCKED = 'Blocked',
}

export enum TaskParticipantRole {
    ASSIGNEE = 'Assignee',
    REVIEWER = 'Reviewer',
}

export interface TaskAssignee {
    id: string;
    task: Task;
    member: Member;
    permission: TaskAssigneePermissionType | undefined;
    status: TaskAssigneeStatusType | undefined;
    role: TaskParticipantRole;
    createdAt: Date;
    updatedAt: Date;
}
